import { useQuery } from '@tanstack/react-query'
import {
  fetchSession,
  hasDeviceAuthSession,
} from '~/adapter/api/deviceAuthSession'
import type { FetchSessionResult } from '~/adapter/api/deviceAuthSession'
import { getDeviceAuthTokenEndpoint } from '~/config'
import { getQueryKey } from '~/lib/tanstackQuery/queryKey'

export { hasDeviceAuthSession }

/**
 * キオスク端末アカウント (Device) のセッション状態を検出する。
 *
 * - 既にデバイスセッションがある（harami_expire_at Cookie あり）→ そのまま有効とみなす。
 *   期限切れでも、後続の GET /me 前にリフレッシュ middleware が再取得するためここでは期限を見ない。
 * - セッションが無い → デバイスセッション作成（fetchSession）を試みる。
 *   fetchSession は mTLS トークン取得（クライアント証明書の有無確認を兼ねる）→ /auth/sessions を
 *   行うため、別途ヘルスチェックでトークンエンドポイントへ POST せず 1 回に集約する。
 *   証明書が無い等で失敗した場合は success:false を返す。
 */
export const useDeviceAuthSession = ({ enabled } = { enabled: true }) => {
  return useQuery({
    queryKey: getQueryKey(getDeviceAuthTokenEndpoint(), 'POST'),
    queryFn: async (): Promise<FetchSessionResult> => {
      if (hasDeviceAuthSession()) {
        return { success: true }
      }
      return await fetchSession()
    },
    enabled,
    throwOnError: false,
    gcTime: 0,
    staleTime: 0,
  })
}
